export default "__VITE_ASSET__ChzfRZwS__"